import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  // PatchFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
  // FpxIHttpOption
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
 import { Customerdedupe, CustomerdedupeMaintanence } from './customerdedupe.model';
import { environment } from 'src/environments/environment';
import { RcobService } from 'src/app/rcob/services/rcob.service';
@Injectable({
  providedIn: 'root'
})
export class CustomerdedupeService implements BaseFpxDataService<any> {
   customerDedupe:any;
   noResult:boolean=false;
   continueApplication = new EventEmitter();

 constructor(private _httpProvider : HttpProviderService,
  private _rcobService:RcobService) { }
  create(payload: Customerdedupe): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setServerContext(environment.customersPublisher);
      httpRequest.setResource('/customerdedupe');
      let bodyContent = {"customerdedupe":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider
        .invokeRestApi(httpRequest,)
        .pipe(
          map(
            (res: IHttpSuccessPayload<CustomerdedupeMaintanence>) =>{
             this.customerDedupe =res.body?.customerdedupe || [];
             if( this.customerDedupe.length == 0 || res.status == 204 || res.status== 500) this.noResult=true;
             this._rcobService.removeData('dedupeSearchResult');
             this._rcobService.setData('dedupeSearchResult', this.customerDedupe);
            }),
            catchError((err:any) => {
              if(err)
                this.noResult=true
              return of(null)
            }));
    };
  }

  findByKey(key: Customerdedupe): FindByKeyFn<Customerdedupe|null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/customerdedupe/{mobileNumber}');
       httpRequest.addPathParameter('mobileNumber', key.mobileNumber);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.customerdedupe ?? null), map((res:any) => {
          return res ? {...res, } : null
        }),catchError((err:any) => {
              return of(null)
            }));

    };
  }

  modify(payload: Customerdedupe): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/customerdedupe/{mobileNumber}');
       httpRequest.addPathParameter('mobileNumber', payload.mobileNumber);
     httpRequest.setMethod('PUT');
      let bodyContent = {"customerdedupe":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,);
    };
  }

  //  patch(payload: Customerdedupe): PatchFn<any> {
  //   return () => {
  //     const httpRequest = new HttpRequest();
  //     httpRequest.setResource('/customerdedupe/{mobileNumber}');
  //      httpRequest.addPathParameter('mobileNumber', payload.mobileNumber);
  //    httpRequest.setMethod('PUT');
  //     let bodyContent = {"customerdedupe":payload};
  //     httpRequest.setBody(bodyContent);
  //     return this._httpProvider.invokeRestApi(httpRequest,);
  //   };
  // }

 findAll(criteriaQuery: CriteriaQuery): FindAllFn<Customerdedupe[]> {
  return () => {
    // let data = this._rcobService.getData('dedupeSearchResult');
      return of(this.customerDedupe);
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/customerdedupe');
      httpRequest.setMethod('GET');
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest,)
        .pipe(
          map(
            (res: IHttpSuccessPayload<CustomerdedupeMaintanence>) =>
              res.body.customerdedupe || [],
          )
        );
    };
  }


     lookup(key: any): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      httpRequest.setResource('/customerdedupe');
      httpRequest.addQueryParameter('lookup', 1);
      const httpCriteria = new CriteriaQuery();
	  httpCriteria.setPaginationCriteria('1', 10);
	  httpCriteria.addFilterCritertia('text', 'String', 'startsWith', {
	  searchText: key.searchText ?? '',
	  });
	  httpRequest.setCriteriaQuery(httpCriteria);

      return this._httpProvider.invokeRestApi(httpRequest,).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }

  loadSummary(criteriaQuery: CriteriaQuery): FindAllFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource("/customerdedupe/stats");
      httpRequest.setMethod("GET");
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest,)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body));
    };
  }
}
